import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query MFARequest {
    mfaRequest {
      success
      phoneNumberLastDigits
    }
  }
`

export const mfaRequestKey = getQueryNames(query)[0]

export default query
